import React from 'react';
import { Box } from '@mui/material';
import { Chip } from '../../../../Chip';
import { Typography } from '../../../../Typography';
import { getStatusChipColor, parseCleaningHistory } from '../../utils';

export interface CleaningHistoryListProps {
  /**
   * Translation function.
   */
  t: (key: string, options?: Record<string, string | number>) => string;
  /**
   * The raw newline-delimited `cleanHistory` string.
   */
  history?: string;
}

/**
 * Renders the parsed cleaning history as a list of date + status-chip rows.
 */
export const CleaningHistoryList: React.FC<CleaningHistoryListProps> = ({ t, history }: CleaningHistoryListProps) => {
  const entries = parseCleaningHistory(history);

  if (entries.length === 0) {
    return (
      <Typography sx={{ fontSize: '13px', color: '#667085' }}>
        {t('asset:cleaning_management:no_history', { defaultValue: 'No history yet' })}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #EAECF0',
        borderRadius: '8px',
        overflow: 'hidden',
      }}
    >
      {entries.map((entry, index) => (
        <Box
          key={`${entry.date}-${entry.status}-${index}`}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '8px 12px',
            borderBottom: index === entries.length - 1 ? 'none' : '1px solid #F2F4F7',
          }}
        >
          <Typography sx={{ fontSize: '13px', color: '#475467', width: '110px' }}>{entry.date}</Typography>
          {entry.status && <Chip label={entry.status} color={getStatusChipColor(entry.status)} size="small" />}
        </Box>
      ))}
    </Box>
  );
};
